<template>
  <div>
      <h2 class="text-xl font-bold mb-4">Selecciona el tipo de entrevista</h2>
      <div class="flex gap-4">
          <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="selectType('predefined')">
              Entrevista Predefinida
          </button>
          <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="selectType('custom')">
              Entrevista Personalizada
          </button>
      </div>
  </div>
</template>
<script>
export default {
  props: ['setInterviewType', 'nextStep'],
  methods: {
      selectType(type) {
          this.setInterviewType(type);
           this.$emit('next');
      }
  }
}
</script>